import { Commons } from '../../utils/commons'
import { Events } from '../../utils/servicesEvents'
import { AppDataController } from '../appData/controller'
import { TransactionController } from '../transaction/controller'
import { Formatter } from './formatter'

class AppNotificationController {
  static async initListeners() {
    Events.handleEvent(
      'received_forground_fcm_notification',
      AppNotificationController.onFcmNotification,
    )

    Events.handleEvent(
      'received_notification',
      AppNotificationController.onFcmNotification,
    )

    Events.handleEvent('received_background_fcm_notification', data => {
      console.log('notification controller got background notif')
      AppNotificationController.onFcmNotification(data)
    })

    Events.handleEvent('received_socket_notification', data => {
      AppNotificationController.onSocketNotification(data)
    })

    Events.handleEvent('single_transaction_updated', async data => {
      const title = data.operationNameDisplay
      const body = data.statusMessage
      if (data.status == 'pending') return
      AppNotificationController.showNotification(body, title)
      const notifType =
        data.status == 'success'
          ? 'success'
          : data.status == 'error'
            ? 'danger'
            : 'info'
      Events.dispatchEvent('toast_notification', {
        title,
        body,
        type: notifType,
      })
    })

    Events.handleEvent('single_pending_operation_saved', async data => {
      const title = data.metaData?.operationTitle
      const body = data.metaData?.operationDescription
      AppNotificationController.showNotification(
        title,
        body,
        `pending-operation-${data.reference}`,
      )
      Events.dispatchEvent('toast_notification', {
        title,
        body,
        type: 'info',
      })
    })

    Events.handleEvent('display_notif_available', async data => {
      const title = data.title
      const body = data.description
      AppNotificationController.showNotification(
        title,
        body,
        // `display-notif-${Date.now()}`,
      )
      Events.dispatchEvent('toast_notification', {
        title,
        body,
        type: 'info',
      })
    })
  }

  static showNotification(title, body, id) {
    if (!title || !body) {
      console.error('bad title or body')
      return
    }
    console.log(title, body)
    if (
      Commons.contentTransactionTerm(title) ||
      Commons.contentTransactionTerm(body)
    ) {
      TransactionController.downloadData()
      AppDataController.downloadUserData()
    }
    try {
      if (window.showNotification) {
        window.showNotification(title, body, id)
        return
      }
    } catch (error) {
      console.warn(error)
    }
    try {
      if (window.Notification && navigator.serviceWorker) {
        navigator.serviceWorker.register('firebase-messaging-sw.js')
        navigator.serviceWorker.ready.then(registration => {
          registration.showNotification(title, {
            body,
            icon: '/images/logo.png',
            badge: '/images/logo.png',
          })
        })
        return
      }
    } catch (error) {
      console.warn(error)
    }
    try {
      if (self?.registration?.showNotification) {
        self.registration.showNotification(title, {
          body,
          icon: '/images/logo.png',
          badge: '/images/logo.png',
        })
      }
    } catch (error) {
      console.warn(error)
    }
  }

  static onFcmNotification(rawNotification) {
    if (isDataNotif(rawNotification)) {
      const notif = Formatter.parseFcmNotification(rawNotification)
      const rawNotif = Commons.changeToJson(notif)
      if (!rawNotif?.contentName) {
        console.error(
          'notification got but has not been parsed correctry',
          rawNotif,
        )
        return
      }
      Events.dispatchEvent(rawNotif.contentName, rawNotif)
    }
    if (isDisplayNotif(rawNotification)) {
      const title = rawNotification?.notification?.title || 'Notification'
      const body = rawNotification?.notification?.body || ''
      AppNotificationController.showNotification(title, body)
    }
  }

  static onSocketNotification(rawNotification) {
    if (isDataNotif(rawNotification)) {
      const notif = Formatter.parseSocketNotification(rawNotification)
      const rawNotif = Commons.changeToJson(notif)
      if (!rawNotif?.contentName) {
        console.error(
          'notification got but has not been parsed correctry',
          rawNotif,
        )
        return
      }
      Events.dispatchEvent(rawNotif.contentName, rawNotif)
    }
    if (isDisplayNotif(rawNotification)) {
      const title = rawNotification?.notification?.title || 'Notification'
      const body = rawNotification?.notification?.body || ''
      AppNotificationController.showNotification(title, body)
    }
  }

  static onNotificationAvailable(notif) {
    // let eventName = "notification_not_decoded";
    // if (notif.type === "transactionLaunched")
    //   eventName = "new_pending_transaction_available";
    // Events.dispatchEvent(eventName, notif.content);
  }
}

function isDisplayNotif(notif) {
  return notif?.notification?.title || notif?.notification?.body
}

function isDataNotif(notif) {
  return notif?.data
}

export { AppNotificationController }
